(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kuva-tai-video"] && !Shopify.designMode) return;
  try {
    // Jos selain estää automaattisen toiston (esim. iPhonen virransäästötila),
  // video käynnistyy ensimmäisestä kosketuksesta tai vierityksestä.
  (() => {
    const kaynnista = () => {
      document.querySelectorAll('.kuva-tai-video video').forEach((video) => {
        video.muted = true;
        const yritys = video.play();
        if (yritys && typeof yritys.catch === 'function') yritys.catch(() => {});
      });
    };
    kaynnista();
    ['touchstart', 'scroll', 'click'].forEach((tapahtuma) =>
      window.addEventListener(tapahtuma, kaynnista, { once: true, passive: true })
    );
    document.addEventListener('shopify:section:load', kaynnista);
  })();
  } catch(e) { console.error(e); }
})();

})();
